import { render, staticRenderFns } from "./UnloadingFactory.vue?vue&type=template&id=127855e1"
import script from "./UnloadingFactory.vue?vue&type=script&lang=js"
export * from "./UnloadingFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports